import { sendEvent } from 'botframework-webchat-core/lib/index';
import { STORE_ACTION_TYPES } from '../eventTypes/storeActions';
import { MESSAGE_EVENTS } from '@sa/cassius-contract';

/**
 * Store middleware that handles incoming app message events.
 * @param dispatch the store dispatch function.
 */
export const incomingAppMessageHandlerMiddleware = ({ dispatch }) => (next) => (action) => {
  if (STORE_ACTION_TYPES.includes(action.type)) {
    const { type, data } = action.payload;
    if (MESSAGE_EVENTS.includes(type)) {
      // Route these events directly to the bot
      dispatch(sendEvent(type, data || {}));
    }
  }
  return next(action);
};
